<template>
  <div style="background-color: #fff;">
    <AchievementsHeader />
    <!-- <div class="bannerBox">
      <a-carousel :dot-position="bottom">
        <div>
          <img class="bannerImg" src="@/assets/img/kjcg-cgxq.jpg" />
        </div>
      </a-carousel>
    </div> -->
    <div class="breadBox">
      <a-breadcrumb>
        <span>
          <img src="@/assets/img/position.png" />
          当前位置：
        </span>
        <a-breadcrumb-item>首页</a-breadcrumb-item>
        <a-breadcrumb-item>{{ title }}</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="contBox">
      <a-tabs v-model:activeKey="activeKey" tab-position="left">
        <a-tab-pane key="1" tab="技术转让">
          <achievementEvelution />
        </a-tab-pane>
        <a-tab-pane key="2" tab="技术需求">
          <achievementDemand />
        </a-tab-pane>
      </a-tabs>
    </div>
    <LayoutFooter />
  </div>
</template>
<script>
import AchievementsHeader from './achievementsHeader';
import achievementEvelution from './achievementEvelution';
import achievementDemand from './achievementDemand';
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';

export default {
  name: 'innovationBigData',
  mixins: [],
  components: { AchievementsHeader, achievementEvelution, achievementDemand, LayoutFooter },
  data() {
    return {
      activeKey: '1',
      title: '',
    }
  },
  mounted() {
    this.title = this.$route.query.type
    this.activeKey = this.$route.query.activeKey || this.$route.query.tab
  },
}
</script>
<style scoped lang="less">
.bannerBox {
  position: relative;
  width: 100%;
  //margin-bottom: 20px;

  .bannerImg {
    width: 100%;
    height: 100%;
  }
}

.breadBox,
.contBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
}

:deep(.ant-tabs .ant-tabs-left-bar) {
  width: 20%;
}

:deep(.ant-tabs .ant-tabs-left-bar .ant-tabs-tab) {
  text-align: center;
  margin: 0;
  padding: 16px 0;

  // &::before {
  //   content: '' !important;
  //   border-left: 4px solid #fc550b !important;
  // }
}

:deep(.ant-tabs-nav .ant-tabs-tab-active) {
  color: #fc550b;
  background-color: #ffeee6;
  text-align: center;
}

:deep(.ant-tabs-ink-bar) {
  background-color: #fc550b;
}

:deep(.ant-tabs-nav .ant-tabs-tab:hover) {
  color: #fc550b;
}
</style>
